import React, { FC } from 'react';

import styles from './TicketIcon.module.scss';

const TicketIcon: FC= () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg"
         width="93"
         height="93"
         fill="none"
         viewBox="0 0 93 93">
      <mask id="a"
            width="93"
            height="93"
            x="0"
            y="0"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse">
        <circle cx="46.5"
                cy="46.5"
                r="46.5"
                className={styles.background} />
      </mask>
      <g mask="url(#a)">
        <circle cx="46.5"
                cy="46.5"
                r="46.5"
                className={styles.background}
                transform="rotate(-23.6 46.5 46.5)" />
        <rect width="55"
              height="75"
              x="9.89"
              y="31.39"
              className={styles.ticket}
              rx="2"
              transform="rotate(-23.6 9.9 31.4)" />
        <path className={styles.number}
              d="m39.82 66.07.52 2.22-.58.25a.37.37 0 0 1-.18.03.4.4 0 0 1-.17-.06.56.56 0 0 1-.15-.12.5.5 0 0 1-.08-.2l-.38-1.68-1.03.45.4 1.73c.05.18.03.32-.05.44a.7.7 0 0 1-.3.26l-.56.24-.52-2.22-.58.25c-.12.06-.23.06-.32.01-.08-.05-.15-.18-.2-.37l-.11-.43.95-.41-.35-1.5-1.08.46-.13-.56a.5.5 0 0 1 .04-.35c.05-.1.17-.19.35-.26l.56-.25-.4-1.76a.54.54 0 0 1 .05-.4.6.6 0 0 1 .3-.25l.56-.25.5 2.21 1.04-.45-.5-2.21.55-.25a.43.43 0 0 1 .36 0c.12.04.19.13.22.27l.4 1.75 1.01-.45.14.56c.03.14.02.26-.04.36-.05.1-.17.18-.34.26l-.5.22.34 1.5.71-.3c.13-.07.24-.07.33-.01.09.05.16.17.21.37l.1.42-1.09.48ZM37.5 66l1.03-.45-.34-1.5-1.03.45.34 1.5Zm5.38.06 1.47-.64-1.85-4.25-.22-.53-.66 1.34a.5.5 0 0 1-.14.17.48.48 0 0 1-.32.08.35.35 0 0 1-.14-.05l-.62-.37 1.4-2.86 1.02-.44 2.78 6.36 1.3-.57.41.93L43.28 67l-.4-.93Zm4.54-9.65c.33-.15.66-.23.99-.25a2.08 2.08 0 0 1 1.65.56c.22.2.4.46.53.78.12.27.19.53.2.8.03.26.02.52-.02.79s-.11.53-.2.8l-.3.85-.92 2.4a4 4 0 0 1 .86-.55l1.87-.82a.47.47 0 0 1 .37-.02c.11.03.2.12.25.24l.33.75-5 2.18-.18-.41a.77.77 0 0 1 0-.61l1.24-3.19.25-.75c.08-.24.13-.46.15-.67.02-.21.02-.42 0-.6-.02-.2-.08-.4-.16-.6a1.39 1.39 0 0 0-.28-.42.98.98 0 0 0-.36-.24.91.91 0 0 0-.42-.06c-.15.01-.3.05-.47.12a1.38 1.38 0 0 0-.64.57 1.17 1.17 0 0 0-.13.77c0 .18-.02.31-.1.4-.06.1-.19.16-.37.2l-.7.18c-.1-.37-.14-.72-.11-1.05a2.38 2.38 0 0 1 .82-1.62c.24-.21.52-.39.85-.53ZM53 53.98c.33-.14.66-.23.97-.25.31-.02.6.01.87.1a1.93 1.93 0 0 1 1.18 1.08c.1.23.16.44.18.64a1.49 1.49 0 0 1-.24 1.05c-.1.16-.23.3-.38.44.5-.05.91.02 1.25.2.34.2.6.5.79.93a2.29 2.29 0 0 1-.63 2.77 3.56 3.56 0 0 1-1.9.85 2.27 2.27 0 0 1-1.65-.44c-.25-.18-.49-.4-.73-.67l.45-.47a.7.7 0 0 1 .39-.22c.14-.03.26 0 .36.08.11.1.23.18.35.26a1.44 1.44 0 0 0 .84.26c.16 0 .34-.05.53-.13.2-.1.38-.21.5-.35a1.32 1.32 0 0 0 .36-.91c0-.16-.04-.31-.1-.45a2.04 2.04 0 0 0-.26-.45.77.77 0 0 0-.4-.27 1.38 1.38 0 0 0-.6-.01c-.25.04-.56.14-.93.3l-.39-.89c.3-.13.55-.27.73-.42.18-.14.3-.28.38-.43.08-.15.11-.3.1-.45a1.45 1.45 0 0 0-.12-.48c-.15-.34-.36-.56-.63-.65-.27-.1-.57-.08-.89.06a1.33 1.33 0 0 0-.64.57 1.17 1.17 0 0 0-.13.77c0 .18-.02.31-.1.4-.06.1-.19.16-.37.21l-.7.17c-.1-.37-.14-.72-.11-1.04a2.38 2.38 0 0 1 .82-1.62c.24-.22.52-.4.85-.54Zm9.2 1.49.92-.4.32.72c.03.06.03.13 0 .2-.01.07-.07.12-.15.15l-.66.3.77 1.77-1.08.48-.78-1.78-3.07 1.34a.38.38 0 0 1-.26.02.38.38 0 0 1-.2-.14l-.4-.58 1.43-6.12 1.18-.51 1.98 4.55Zm-2.12-1.92c-.1-.22-.2-.47-.28-.76l-.9 4.12 2.22-.97-1.04-2.39Z" />
        <circle cx="58.51"
                cy="73.99"
                r="6.5"
                className={styles.background}
                transform="rotate(-23.6 58.51 74)" />
        <circle r="1.5"
                className={styles.background}
                transform="rotate(-23.6 210.85 -81.5)" />
        <circle cx="81.42"
                cy="63.98"
                r="1.5"
                className={styles.background}
                transform="rotate(-23.6 81.42 63.98)" />
        <circle r="1.5"
                className={styles.background}
                transform="rotate(-23.6 212.85 -71.93)" />
        <circle cx="77.75"
                cy="65.58"
                r="1.5"
                className={styles.background}
                transform="rotate(-23.6 77.75 65.58)" />
        <circle r="1.5"
                className={styles.background}
                transform="rotate(-23.6 214.85 -62.36)" />
        <circle r="1.5"
                className={styles.background}
                transform="rotate(-23.6 197.84 -143.73)" />
        <circle r="1.5"
                className={styles.background}
                transform="rotate(-23.6 216.85 -52.78)" />
        <circle cx="70.42"
                cy="68.79"
                r="1.5"
                className={styles.background}
                transform="rotate(-23.6 70.42 68.79)" />
        <circle r="1.5"
                className={styles.background}
                transform="rotate(-23.6 218.85 -43.21)" />
        <circle cx="66.76"
                cy="70.39"
                r="1.5"
                className={styles.background}
                transform="rotate(-23.6 66.76 70.39)" />
        <circle cx="34.89"
                cy="19.93"
                r="6.5"
                className={styles.background}
                transform="rotate(-23.6 34.9 19.93)" />
        <circle cx="26.64"
                cy="23.53"
                r="1.5"
                className={styles.background}
                transform="rotate(-23.6 26.64 23.53)" />
        <circle r="1.5"
                className={styles.background}
                transform="rotate(-23.6 52.64 -133.38)" />
        <circle r="1.5"
                className={styles.background}
                transform="rotate(-23.6 71.63 -42.43)" />
        <circle cx="54.13"
                cy="11.52"
                r="1.5"
                className={styles.background}
                transform="rotate(-23.6 54.13 11.52)" />
        <circle r="1.5"
                className={styles.background}
                transform="rotate(-23.6 73.63 -32.86)" />
        <circle cx="50.47"
                cy="13.12"
                r="1.5"
                className={styles.background}
                transform="rotate(-23.6 50.47 13.12)" />
        <circle r="1.5"
                className={styles.background}
                transform="rotate(-23.6 75.63 -23.28)" />
        <circle cx="46.8"
                cy="14.72"
                r="1.5"
                className={styles.background}
                transform="rotate(-23.6 46.8 14.72)" />
        <circle r="1.5"
                className={styles.background}
                transform="rotate(-23.6 77.63 -13.71)" />
        <circle cx="43.14"
                cy="16.32"
                r="1.5"
                className={styles.background}
                transform="rotate(-23.6 43.14 16.32)" />
        <path className={styles.skeleton}
              d="m17.56 38.96 43.07-18.82 1.6 3.67-43.07 18.81zM19.96 44.45l26.57-11.6.8 1.82-26.57 11.61zM21.56 48.12l26.58-11.6.8 1.82-26.58 11.61zM23.16 51.78l26.57-11.6.8 1.82-26.57 11.61zM51.12 30.84l11.91-5.2.8 1.83-11.91 5.2zM52.72 34.51l11.91-5.2.8 1.83-11.9 5.2zM54.32 38.17l11.91-5.2.8 1.83-11.9 5.2zM24.77 55.45l43.07-18.82 1.2 2.75L25.97 58.2z" />
        <path className={styles.numberBorder}
              d="M28.23 62.12 70.38 43.7l5.2 11.92-42.15 18.41z" />
      </g>
    </svg>
  );
};

export default TicketIcon;
